import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Home } from './pages/home/Home';
import { Dnsquery } from './pages/dnsquery/Dnsquery';
import { Dnsresponse } from './pages/dnsresponse/Dnsresponse';
import { Login } from './pages/login/Login';
import { AuthContextProvider, useAuthState } from './services/auth'; //useAuthState
import ProtectedRoutes from './services/protected-routes';
import PublicRoutes from './services/public-routes';
import CustomNavBar from './layouts/navbar/Navbar';
import './App.scss';
import { isMobile, isIOS } from 'react-device-detect';
import { Master } from './layouts/master/master';
import { Manager } from './layouts/manager/manager';
import axios from 'axios';
import { OperatorSummary } from './pages/operator-summary/OperatorSummary';
import { GeneralList } from './pages/cpe-list/GeneralList';
import { OperatorsListProvider } from './services/OperatorsList';
import { CpeDetails } from './pages/cpe-details/CpeDetails';
import { DeviceDetails } from './pages/device-details/DeviceDetails';
import { ToastProvider } from './services/ToastContext';
import { Redirect } from './pages/redirect/Redirect';
import { Dns } from './pages/Dns/Dns';
//import { SocketContext, SocketContextProvider } from './services/SocketContext';
import { Dashboard } from './pages/dashboard/Dashboard';
import { Redisips } from './pages/redisips/Redisips';
import { Trustedips } from './pages/trustedips/Trustedips';
import { ProfileCalc } from './pages/profile-calc/ProfileCalc';
import { LoaderProvider } from './services/LoaderProvider';
import { WebFilters } from './pages/web-filters/WebFilters';
import { MdmPolicy } from './pages/mdm-policy/MdmPolicy';
import { MdmPolicyList } from './pages/mdm-policy-list/MdmPolicyList';
//import { io } from 'socket.io-client';

import { EnvironmentSettings } from './pages/settings/Settings';
import { ThreatsManaged } from './pages/threats-managed/ThreatsManaged';
import { IssuesToCheck } from './pages/issues-check/issuesCheck';
import { ForgotPassword } from './pages/cpe-details/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/cpe-details/ResetPassword/ResetPassword';
import { OperatorTools } from './pages/operator-tools/OperatorTools';
import { LanguageProvider } from './components/language-selector/LanguageContext';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
// import i18n from './util/i18n';
import { OperatorStats } from './components/websocket/BlackdiceWebSocket';
import { Button } from 'react-bootstrap';
import { FaMoon, FaSun } from 'react-icons/fa';
import OperationalConsole from './pages/OperationalConsole/operationalConsole';
import { CveDetailsPage } from './components/CveDetailsPage/CveDetailsPage';
import { DashboardV2 } from './pages/dashboard-v2/dashboardV2';
import { NOCAnalyst } from './layouts/noc-analyst/noc-analyst';

import { config } from './config';

function App() {
  axios.defaults.baseURL = config.API_URL;

  const isManager = window.location.pathname.indexOf('/manager') != -1;
  // Custom hook for theme management
  
  const useTheme = () => {

    const [darkMode, setDarkMode] = useState<boolean>(() => {
      const savedMode = localStorage.getItem('darkMode');
      if (savedMode) {
        return JSON.parse(savedMode);
      }
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    });

    useEffect(() => {
      const root = document.documentElement;
      root.classList.toggle('dark-theme', darkMode);
      root.classList.toggle('light-theme', !darkMode);

      // Update meta theme color
      const metaThemeColor = document.querySelector('meta[name="theme-color"]');
      if (metaThemeColor) {
        metaThemeColor.setAttribute('content', darkMode ? '#121212' : '#ffffff');
      }
    }, [darkMode]);

const toggleTheme = () => {
  setDarkMode(prevMode => {
    const newMode = !prevMode;
    localStorage.setItem('darkMode', JSON.stringify(newMode));
    console.log(`Theme changed to: ${newMode ? 'Dark' : 'Light'}`);
    return newMode;
  });
};
useEffect(() => {
  const root = document.documentElement;
  root.classList.toggle('dark-theme', darkMode);
  root.classList.toggle('light-theme', !darkMode);

  const metaThemeColor = document.querySelector('meta[name="theme-color"]');
  if (metaThemeColor) {
    metaThemeColor.setAttribute('content', darkMode ? '#121212' : '#ffffff');
  }
}, [darkMode]);

    return { darkMode, toggleTheme };
  };
  
  // Add a request interceptor
  axios.interceptors.request.use(
    (config) => {
      const token = window.localStorage.getItem('loginToken');
      if (token) {
        config.headers['auth-token'] = config.headers['auth-token'] || token;
      }

      if (config.url && !config.url.includes('undefined')) {
        // config.headers['Content-Type'] = 'application/json';
        return config;
      } else {
        // Log an error or handle it accordingly
        console.error('URL is undefined');
        // Returning a rejected promise to stop the request
        return Promise.reject('URL is undefined');
      }
    },
    (error) => {
      // Handle request error
      return Promise.reject(error);
    }
  );

  function getCurrentNav(): string {
    return window.localStorage.getItem('currentNav') || 'Home';
  }

  function isActive(page: string) {
    if (getCurrentNav() === page) {
      return ' active';
    } else {
      return '';
    }
  }

  const { i18n } = useTranslation();
  const language = i18n.language; // i18next owns the choice and persists it (util/i18n.js)
  const { darkMode, toggleTheme } = useTheme();
  const handleLanguageChange = async (newLanguage: { key: string; name: string }) => {
    await i18n.changeLanguage(newLanguage.key);
  };

  return (
    <LanguageProvider>
      <Router>
        <LoaderProvider>
          <AuthContextProvider>
            <OperatorsListProvider>
              {/*          <SocketContextProvider> */}
              <ToastProvider>
                <div className={'main-content-container'}>
                  <CustomNavBar  darkMode={darkMode}  toggleTheme={toggleTheme}  isActive={isActive}  />
                  <Master>
                    <div className={`main w-full `} style={{ borderRadius: 0 }}>
                      <div className={'main-content ' + (isMobile ? ' mobile' : '') + (isIOS ? ' iOS' : '') +(darkMode? 'dark-theme':'light-theme')}>                 
                        <Routes>
                          <Route path="/redirect" element={<Redirect />} />
                          <Route path="/" element={<ProtectedRoutes />}>
                            <Route path="operators" element={<Home darkMode={darkMode} />} />
                            {/* <Route path="Operational/:operatorId" element={<OperationalConsole  />} /> */}
                            <Route path="operators/websocket" element={<OperatorStats />} />
                            <Route path="operators/webfilters" element={<WebFilters darkmode={darkMode} />} />
                            <Route path="operators/mdmpolicy" element={<MdmPolicy />} />
                            <Route path="operators/mdm-list" element={<MdmPolicyList />} />

                            {/* Route to Environment Settings */}
                            <Route path="operators/web-filters" element={<WebFilters darkmode={darkMode} />} />
                            <Route path="operators/settings" element={<EnvironmentSettings darkmode={darkMode} onLanguageChange={handleLanguageChange} selectedLanguage={language} />} />

                            <Route path="operators/:operatorId" element={<OperatorSummary darkMode={darkMode} isActive={isActive} />} />
                            {/* <Route path="operators/:operatorId" element={<OperatorSummary darkMode={darkMode} isActive={isActive} />} /> */}
                            <Route path="threatsmanaged/:operatorId" element={<ThreatsManaged darkMode={darkMode} />} />
                            <Route path="issuesCheck/:operatorId" element={<IssuesToCheck />} />
                            <Route path="operators/:operatorId/cpe/:cpeId" element={<CpeDetails darkMode={darkMode} isActive={isActive} />} />
                            <Route path="operators/:operatorId/cpe/:cpeId/d/:deviceId/:type" element={<DeviceDetails darkmode={darkMode} />} />
                            <Route path="operators/:operatorId/cve/:cveId" element={<CveDetailsPage />} />

                            <Route path="general-list/:apiUrl/:title" element={<GeneralList />} />
                            <Route path="general-list/:operatorId/:apiUrl/:title" element={<GeneralList darkMode={darkMode} />} />
                            <Route path="profile-calc" element={<ProfileCalc />} />

                            <Route path="/" element={<Navigate to="operators" />} />
                            <Route path="dnsactivity/:operatorId" element={<Dns darkMode={darkMode} />} />
                            <Route path="operator-tools/:operatorId" element={<OperatorTools darkmode={darkMode}  />} />
                          </Route>

                          <Route path="/" element={<PublicRoutes />}>
                            <Route path="login" element={<Login />} />
                            <Route path="forgot-password" element={<ForgotPassword />} />
                            <Route path="reset-password" element={<ResetPassword />} />
                          </Route>

                          <Route path="login" element={<Login />} />
                        </Routes>
                        <Manager>
                          <Routes>
                            <Route path="/manager/dashboard" element={<Dashboard />} />
                            <Route path="/manager/dnsquery" element={<Dnsquery />} />
                            <Route path="/manager/dnsresponse" element={<Dnsresponse />} />
                            <Route path="/manager/redisips" element={<Redisips />} />
                            <Route path="/manager/trustedips" element={<Trustedips />} />
                          </Routes>
                        </Manager>
                        <NOCAnalyst>
                          <Routes>
                            <Route path="/noc-analyst/dashboard" element={<DashboardV2 />} />
                          </Routes>
                        </NOCAnalyst>
                      </div></div>
                  </Master>
                </div>
              </ToastProvider>
              {/*  </SocketContextProvider> */}
            </OperatorsListProvider>
          </AuthContextProvider>
        </LoaderProvider>
      </Router>
    </LanguageProvider>
  );
}

export default App;
